/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var CorpFinRecordHeaderBarView = require('../../common/views/CorpFinRecordHeaderBarView');
var BreadcrumbView = require('common/views/BreadcrumbView');

var CorpFinInvPortfolioFormView = require('./CorpFinInvPortfolioFormView');

var SubmitPortfolio = require('../services/SubmitPortfolio');

var tmplCorpFinInvPortfolioEditView = require('../templates/CorpFinInvPortfolioEditView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinInvPortfolioEditView,

  className: 'corp-fin-inv-portfolio-edit-view container-fluid',

  ui: {
    invPortfolioForm: '.inv-portfolio-form-container',
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container',
    submit: '.submit'
  },

  regions: {
    invPortfolioForm: '@ui.invPortfolioForm',
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var record = this.model.get('record') || {};
    var recordId = this.model.get('recordId');
    var fileNumber = record.fileNumber;

    this.showChildView(
      'headerBar',
      new CorpFinRecordHeaderBarView({
        model: new Backbone.Model(record)
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#corpfin/dashboard',
            text: 'Home'
          },
          {
            link: '#corpfin/investment/' + recordId + '/dashboard',
            text: 'Investment (' + fileNumber + ')'
          },
          {
            text: 'Edit Portfolio'
          }
        ]
      })
    );

    this.invPortfolioForm = new CorpFinInvPortfolioFormView({
      model: this.model
    });

    this.showChildView('invPortfolioForm', this.invPortfolioForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();

        SubmitPortfolio(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:cf:investment-dashboard', formData.recordId);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.invPortfolioForm.parsley().whenValidate();
  },

  getFormData: function() {
    var formData = this.invPortfolioForm.getFormData();
    formData.portfolioId = this.model.get('portfolioId');
    formData.recordId = this.model.get('recordId');
    return formData;
  }
});
